module.exports = __webpack_public_path__ + "media/images/icon-carrot-up-943577906ea3a97d788d68814e235a19.svg";